module.exports = __webpack_public_path__ + "d2807a06f44dbc8a2ef74145bf7e2a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201602_Presse_AVANGA_HZDR_114KB.jpg
// module id = 563
// module chunks = 0